import React from 'react';
import { createRoot } from 'react-dom/client';
import { BaseQuoteToolLauncher } from '@PetSureAustralia/petsure-quote-tool-base/distBaseQuoteTool/components/BaseQuoteTool/BaseQuoteToolWrapper';

import { QuoteToolConfigs } from '../quoteToolConfigs';
import { BrandMetaTags } from '../../../components/BrandMetaTags';
import { AdFixusScriptTags } from '../../../components/AdFixusScriptTags';
import { initSentry } from '../../../helpers/initSentry';

export const PIAGlm3PublicQuoteTool = () => (
  <>
    <AdFixusScriptTags {...QuoteToolConfigs.public.tool?.brandConfig?.theme} />
    <BrandMetaTags {...QuoteToolConfigs.public.meta} />
    <BaseQuoteToolLauncher {...QuoteToolConfigs.public.tool} />
  </>
);

initSentry({ brand: 'piaglm3' });
const rootElement = document.getElementById('app');
const root = createRoot(rootElement);

root.render(<PIAGlm3PublicQuoteTool />);
